import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import './UnusualActivityBanner.css';

function UnusualActivityBanner() {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);
  const [alertData, setAlertData] = useState(null);

  useEffect(() => {
    const handleAlert = (event) => {
      setAlertData(event.detail);
      setVisible(true);

      // Auto-dismiss after 5 seconds
      setTimeout(() => {
        setVisible(false);
      }, 5000);
    };

    window.addEventListener('unusualActivityAlert', handleAlert);

    return () => {
      window.removeEventListener('unusualActivityAlert', handleAlert);
    };
  }, []);

  if (!visible || !alertData) return null;

  return (
    <div className={`unusual-activity-banner ${visible ? 'visible' : ''}`}>
      <div className="banner-content">
        <span className="banner-icon">🚨</span>
        <div className="banner-text">
          <strong>{t('unusualActivity.detected')}</strong>
          <span className="banner-warning">{t('unusualActivity.volatile')}</span>
          <span className="banner-details">
            {alertData.tradesCount} large trades (${(alertData.totalVolume / 1_000_000).toFixed(1)}M)
            in the last {alertData.timeWindow}
          </span>
        </div>
        <button
          className="banner-close"
          onClick={() => setVisible(false)}
          aria-label="Close"
        >
          ×
        </button>
      </div>
    </div>
  );
}

export default UnusualActivityBanner;
